"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeoMatrix = getKeoMatrix;
exports.firstEightRowsHeader = firstEightRowsHeader;
exports.addMatrixHeaders = addMatrixHeaders;
exports.insertNoDataMessage = insertNoDataMessage;
exports.insertMatrixData = insertMatrixData;
exports.updateTimestamp = updateTimestamp;
exports.formatSingleRow = formatSingleRow;
exports.isSheetFormattedCorrectly = isSheetFormattedCorrectly;
exports.getWasteCodeList = getWasteCodeList;
exports.insertMatrixDataToSheet = insertMatrixDataToSheet;
exports.insertMissingWasteCodes = insertMissingWasteCodes;
var headers_1 = require("../headers");
var keo_card_1 = require("./keo_card");
var common_1 = require("../common");
var headers = headers_1.KEO_ANNUAL_PERMIT_HEADERS;
var sheetHeaders = headers_1.SHEET_EIGHT_HEADERS;
/**
 * Pobiera dane KEO i mapuje je na listę ReportKeoData
   * @param eupType - Typ EUP
 * @param Year - Rok
 * @returns Lista ReportKeoData
 */
function getKeoMatrix(eupType, year) {
    return __awaiter(this, void 0, void 0, function () {
        var keoList, matrix, uniqueWasteCodes, sortedWasteCodes, limitedWasteCodes, reportKeoList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, keo_card_1.getKeoDMonthlyStatementataAndMappingToList)(eupType.clientId, eupType.clientSecret, eupType.eupId, year)];
                case 1:
                    keoList = _a.sent();
                    matrix = [];
                    matrix.push(headers);
                    // Sprawdzenie czy keoList jest pusty
                    if (keoList.length === 0) {
                        return [2 /*return*/, matrix]; // Zwraca pustą macierz z nagłówkami
                    }
                    uniqueWasteCodes = new Set();
                    keoList.forEach(function (item) {
                        if (item.wasteCode && !uniqueWasteCodes.has(item.wasteCode)) {
                            uniqueWasteCodes.add(item.wasteCode);
                        }
                    });
                    sortedWasteCodes = Array.from(uniqueWasteCodes).sort();
                    limitedWasteCodes = (0, common_1.limitTrialData)(sortedWasteCodes, eupType.isTrial);
                    reportKeoList = [];
                    reportKeoList.push.apply(reportKeoList, limitedWasteCodes.map(function (wasteCode) {
                        var item = keoList.find(function (i) { return i.wasteCode === wasteCode; });
                        return {
                            wasteCode: wasteCode || "",
                            wasteCodeDescription: item ? item.wasteCodeDescription || "" : "",
                            isDangerous: (0, common_1.isDangerousWaste)(wasteCode),
                            wasteMassInstallation: 0,
                            wasteMassExcludingInstallation: 0,
                            totalWasteMass: 0,
                            maximumAccordingToPermit: null,
                            percentageOfPermit: null
                        };
                    }));
                    // Sprawdzenie czy reportKeoList nie jest puste
                    if (reportKeoList.length > 0) {
                        reportKeoList.forEach(function (item) {
                            var itemData = keoList.find(function (i) { return i.wasteCode === item.wasteCode; });
                            if (itemData) {
                                var totalInstallation = keoList
                                    .filter(function (card) { return card.wasteCode === item.wasteCode && card.Generated && Array.isArray(card.Generated.items); })
                                    .flatMap(function (card) { return card.Generated.items; })
                                    .reduce(function (sum, item) { var _a; return sum + ((_a = item.wasteMassInstallation) !== null && _a !== void 0 ? _a : 0); }, 0);
                                item.wasteMassInstallation = totalInstallation;
                                var totalExcludingInstallation = keoList
                                    .filter(function (card) { return card.wasteCode === item.wasteCode && card.Generated && Array.isArray(card.Generated.items); })
                                    .flatMap(function (card) { return card.Generated.items; })
                                    .reduce(function (sum, item) { var _a; return sum + ((_a = item.wasteMassExcludingInstallation) !== null && _a !== void 0 ? _a : 0); }, 0);
                                item.wasteMassExcludingInstallation = totalExcludingInstallation;
                                item.totalWasteMass = totalInstallation + totalExcludingInstallation;
                            }
                        });
                    }
                    //reportKeoList to matrix
                    reportKeoList.forEach(function (item) {
                        matrix.push([
                            item.wasteCode,
                            item.isDangerous ? "Tak" : "Nie",
                            item.wasteCodeDescription,
                            item.wasteMassInstallation,
                            item.wasteMassExcludingInstallation,
                            item.totalWasteMass,
                            item.maximumAccordingToPermit,
                            item.percentageOfPermit
                        ]);
                    });
                    return [2 /*return*/, matrix];
            }
        });
    });
}
/**
 * Metoda tworzy nagłówek arkusza - pierwsze 8 wierszy oraz formaruje szerokości kolum dla danych
 * @param sheetName - nazwa arkusza
    * @param eupType - Typ EUP
 * @param year - rok zestawienia
 * @param dateTo - data końcowa
 */
function firstEightRowsHeader(sheetName, eupType, year) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, ReportId, headerTitleRange, headerValueRange, currentdate, formattedDate;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    ReportId = "CW12";
                                    // Ustawienie koloru tła dla całego arkusza
                                    sheet.getRange("A1:H8").format.fill.color = "#E7E7E7";
                                    // Wysokości pierwszych 8 wierszy
                                    sheet.getRange("1:1").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("2:2").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("3:3").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("4:4").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("5:5").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("6:6").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("7:7").format.rowHeight = common_1.firstSevenRowsHeight;
                                    sheet.getRange("8:8").format.rowHeight = common_1.firstSevenRowsLastRowHeight;
                                    // Formatowanie kolumn
                                    sheet.getRange("A:A").format.columnWidth = 100;
                                    sheet.getRange("B:B").format.columnWidth = 155;
                                    sheet.getRange("C:C").format.columnWidth = 360;
                                    sheet.getRange("D:H").format.columnWidth = 215;
                                    headerTitleRange = sheet.getRange("A1:A7");
                                    headerTitleRange.format.fill.color = "#688BBB";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    sheet.getRange("A1").values = [[sheetHeaders.REPORT_TITLE]];
                                    sheet.getRange("A1:B1").merge();
                                    sheet.getRange("A1:B1").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A1:B1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A2").values = [[sheetHeaders.DESCRIPTION]];
                                    sheet.getRange("A2:B2").merge();
                                    sheet.getRange("A2:B2").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A2:B2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A3").values = [[sheetHeaders.BDOENTITY]];
                                    sheet.getRange("A3:B3").merge();
                                    sheet.getRange("A3:B3").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A3:B3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A4").values = [[sheetHeaders.MPD]];
                                    sheet.getRange("A4:B4").merge();
                                    sheet.getRange("A4:B4").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A4:B4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A5").values = [[sheetHeaders.MPD_NUMBER]];
                                    sheet.getRange("A5:B5").merge();
                                    sheet.getRange("A5:B5").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A5:B5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A6").values = [[sheetHeaders.REPORT_YEAR]];
                                    sheet.getRange("A6:B6").merge();
                                    sheet.getRange("A6:B6").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A6:B6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("A7").values = [[sheetHeaders.DATA_IMPORT]];
                                    sheet.getRange("A7:B7").merge();
                                    sheet.getRange("A7:B7").format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                    sheet.getRange("A7:B7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    headerValueRange = sheet.getRange("C1:C7");
                                    headerValueRange.format.fill.color = "#F7F7F7";
                                    headerValueRange.format.font.color = "#000000";
                                    headerValueRange.format.font.size = common_1.firstSevenRowsFontSize;
                                    headerValueRange.format.verticalAlignment = "Center";
                                    sheet.getRange("C1").values = [["".concat(ReportId, " - ZESTAWIENIE ROCZNE ODPAD\u00D3W i POZWOLENIA")]];
                                    sheet.getRange("C1").format.font.bold = true;
                                    sheet.getRange("C1").format.font.color = "#688BBB";
                                    sheet.getRange("C1").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C1").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("C2").values = [["Zestawienie ilości odpadów wytworzonych w danym roku w odniesieniu do limitów określonych w pozwoleniu na wytwarzanie odpadów"]];
                                    sheet.getRange("C2").format.wrapText = true;
                                    sheet.getRange("C2").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C2").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("C3").values = [[eupType.bdoentityname || "Brak danych"]];
                                    sheet.getRange("C3").format.wrapText = true;
                                    sheet.getRange("C3").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C3").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("C4").values = [[eupType.name]];
                                    sheet.getRange("C4").format.wrapText = true;
                                    sheet.getRange("C4").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C4").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("C5:C5").numberFormat = [["@"]]; // Format tekstowy ustawiony PRZED wstawieniem wartości
                                    sheet.getRange("C5").values = [[eupType.identificationNumber]];
                                    sheet.getRange("C5").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C5").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    sheet.getRange("C6").values = [[year]];
                                    sheet.getRange("C6").format.horizontalAlignment = "Left";
                                    sheet.getRange("C6").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C6").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    currentdate = new Date();
                                    formattedDate = currentdate.toLocaleDateString("pl-PL", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit"
                                    });
                                    sheet.getRange("C7").values = [[formattedDate]];
                                    sheet.getRange("C7").format.horizontalAlignment = "Left";
                                    sheet.getRange("C7").format.borders.getItem("EdgeBottom").color = "#E7E7E7";
                                    sheet.getRange("C7").format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje nagłówki kolumn dla danych z Matrix
 * @param sheetName - arkusz do wstawienia nagłówka
 */
function addMatrixHeaders(sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, headerTitleRange;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    //B9:AN10
                                    sheet.getRange("9:9").format.rowHeight = common_1.matrixHeadersDefaultRowHeight;
                                    headerTitleRange = sheet.getRange("A9:H9");
                                    headerTitleRange.format.fill.color = "#404040";
                                    headerTitleRange.format.font.bold = true;
                                    headerTitleRange.format.font.color = "#FFFFFF";
                                    headerTitleRange.format.font.size = common_1.matrixHeadersDefaultFontSize;
                                    headerTitleRange.format.verticalAlignment = "Center";
                                    headerTitleRange.format.horizontalAlignment = "Center";
                                    headerTitleRange.format.wrapText = true;
                                    //"Kod odpadu", // A
                                    sheet.getRange("A9").values = [[headers[0]]];
                                    sheet.getRange("A9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("A9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Odpad niebezpieczny", // B
                                    sheet.getRange("B9").values = [[headers[1]]];
                                    sheet.getRange("B9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("B9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Rodzaj odpadu", // C
                                    sheet.getRange("C9").values = [[headers[2]]];
                                    sheet.getRange("C9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("C9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Masa wytworzonych odpadów w związku z eksploatacją instalacji [Mg]", // D
                                    sheet.getRange("D9").values = [[headers[3]]];
                                    sheet.getRange("D9").format.wrapText = true;
                                    sheet.getRange("D9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("D9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Masa wytworzonych odpadów poza instalacją [Mg]", // E
                                    sheet.getRange("E9").values = [[headers[4]]];
                                    sheet.getRange("E9").format.wrapText = true;
                                    sheet.getRange("E9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("E9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Łączna masa wytworzonych odpadów [Mg]", // F
                                    sheet.getRange("F9").values = [[headers[5]]];
                                    sheet.getRange("F9").format.wrapText = true;
                                    sheet.getRange("F9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("F9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Maksymalnie wg pozwolenia na wytwarzanie odpadów [Mg]", // G
                                    sheet.getRange("G9").values = [[headers[6]]];
                                    sheet.getRange("G9").format.wrapText = true;
                                    sheet.getRange("G9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("G9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    //"Procent wartości z pozwolenia na wytwarzanie odpadów [Mg]", // H
                                    sheet.getRange("H9").values = [[headers[7]]];
                                    sheet.getRange("H9").format.wrapText = true;
                                    sheet.getRange("H9").format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                    sheet.getRange("H9").format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda wstawia informacj o braku danych do raportu dla zadanego okresu i dla wybranego MPD
 * @param sheetName - nazwa arkusza
 * @param eupType - Typ EUP
 */
function insertNoDataMessage(sheetName, eupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, noDataMessageRange, columns, rows;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    noDataMessageRange = sheet.getRange("A10:H12");
                                    noDataMessageRange.format.rowHeight = 30;
                                    noDataMessageRange.format.fill.color = "#F6F6F6";
                                    noDataMessageRange.format.font.size = 12;
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    columns = ["A", "B", "C", "D", "E", "F", "G", "H"];
                                    rows = [10, 11, 12];
                                    rows.forEach(function (row) {
                                        columns.forEach(function (col) {
                                            var cellAddress = "".concat(col).concat(row);
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            sheet.getRange(cellAddress).format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    });
                                    sheet.getRange("A11").values = [["Brak danych do raportu dla zadanego okresu i dla wybranego MPD"]];
                                    sheet.getRange("A11").format.font.color = "#F10606";
                                    sheet.getRange("A11").format.font.size = 14;
                                    //sheet.getRange("B11").format.horizontalAlignment = "Center";
                                    sheet.getRange("A11").format.verticalAlignment = "Center";
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    _a.sent();
                                    if (!eupType.isTrial) return [3 /*break*/, 4];
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A14:H14", eupType.isTrial)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: 
                                // Dodanie Copyright w wierszu po ostatnim wpise + 3 wiersze
                                return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A15:H15")];
                                case 5:
                                    // Dodanie Copyright w wierszu po ostatnim wpise + 3 wiersze
                                    _a.sent();
                                    return [4 /*yield*/, context.sync()];
                                case 6:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    return [4 /*yield*/, updateTimestamp(sheet)];
                                case 7:
                                    // Aktywuj arkusz
                                    _a.sent();
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda dodaje dane z MAtrix do arkusza
 * @param sheetName - nazwa arkusza
 * @param matrix - macierz danych do wstawienia
 * @param eupType - Typ EUP
 */
function insertMatrixData(sheetName, matrix, eupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, dataMatrix, rowRange, range, dataRowsCount, _loop_1, i, textFormatColumns, i, rowIndex, formula, conditionalFormat, trialNoticeRow, copyrightRow;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    dataMatrix = matrix.slice(1);
                                    rowRange = 9 + dataMatrix.length;
                                    range = sheet.getRange("A10:H" + (9 + dataMatrix.length));
                                    range.values = dataMatrix;
                                    dataRowsCount = dataMatrix.length;
                                    _loop_1 = function (i) {
                                        var rowIndex = i + 10; // 10 to początkowy wiersz danych
                                        var rowRange_1 = sheet.getRange("A".concat(rowIndex, ":H").concat(rowIndex));
                                        // Wysokość wiersza
                                        rowRange_1.format.rowHeight = 30;
                                        // Kolor tła #F7F7F7
                                        rowRange_1.format.fill.color = "#F7F7F7";
                                        // Kolor czcionki #000000
                                        rowRange_1.format.font.color = "#000000";
                                        // Rozmiar czcionki 12
                                        rowRange_1.format.font.size = 12;
                                        // Wyrównanie tekstu do lewej
                                        rowRange_1.format.horizontalAlignment = "Left";
                                        // Wyrównanie pionowe do środka
                                        rowRange_1.format.verticalAlignment = "Center";
                                        // Dodanie border dół i prawo w kolorze #E9E9E9
                                        rowRange_1.format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                                        rowRange_1.format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                                        // Dodanie prawego obramowania dla każdej komórki w wierszu
                                        var columns = ["A", "B", "C", "D", "E", "F", "G", "H"];
                                        columns.forEach(function (col) {
                                            var cellRange = sheet.getRange("".concat(col).concat(rowIndex));
                                            cellRange.format.borders.getItem("EdgeRight").color = "#E8E8E8";
                                            cellRange.format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                                        });
                                    };
                                    for (i = 0; i < dataRowsCount; i++) {
                                        _loop_1(i);
                                    }
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    //Kolumna A dla wartości matrix jest wyrównana do środka i wartości zapisane jako tekst
                                    sheet.getRange("A10:B" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    textFormatColumns = ["A"];
                                    textFormatColumns.forEach(function (column) {
                                        var columnRange = sheet.getRange("".concat(column, "10:").concat(column) + (9 + dataMatrix.length));
                                        // Stwórz tablicę formatów dla wszystkich komórek w kolumnie
                                        var formatArray = Array(dataMatrix.length).fill(["@"]);
                                        columnRange.numberFormat = formatArray;
                                    });
                                    // Kolumna C wartości Matrix jest wyrównana do lewej i ma zawijanie tekstu
                                    sheet.getRange("C10:C" + (9 + dataMatrix.length)).format.horizontalAlignment = "Left";
                                    sheet.getRange("C10:C" + (9 + dataMatrix.length)).format.wrapText = true;
                                    // Kolumna D wartości Matrix jest wyrównana do środka i jest formatem liczbowym do 4 miejsca po przecinku
                                    sheet.getRange("D10:H" + (9 + dataMatrix.length)).format.horizontalAlignment = "Center";
                                    sheet.getRange("D10:H" + (9 + dataMatrix.length)).numberFormat = [["0.0000"]]; // Format liczbowy do 4 miejsca po przecinku
                                    // Dodanie filtrowania do nagłówków dla całego dodanego zakresu Matrix
                                    sheet.autoFilter.apply(sheet.getRange("A9:H" + (9 + dataMatrix.length)));
                                    // Kolumna G ma kolor tła #E5EEF9
                                    sheet.getRange("G10:G" + (9 + dataMatrix.length)).format.fill.color = "#E5EEF9";
                                    //Kolumna H zawiera formułe liczącą procent wartości z pozwolenia na wytwarzanie odpadów
                                    //Wartość formuły to =IF(G10=0,"nie dotyczy",D10/G10) gdzie sprawdzamy czy w G jest wartość >0
                                    //Jeśli tak, to obliczamy procent (D10/G10*100), jeśli nie to wpisujemy "nie dotyczy"
                                    // Dodanie formuł do kolumny I dla każdego wiersza danych
                                    for (i = 0; i < dataMatrix.length; i++) {
                                        rowIndex = i + 10;
                                        formula = "=IF(OR(G".concat(rowIndex, "=0,G").concat(rowIndex, "=\"\"),\"nie dotyczy\",D").concat(rowIndex, "/G").concat(rowIndex, ")");
                                        sheet.getRange("H".concat(rowIndex)).formulas = [[formula]];
                                    }
                                    // Ustawienie formatowania dla kolumny H - wartości liczbowe jako procenty, tekst bez formatowania
                                    sheet.getRange("H10:H" + (9 + dataMatrix.length)).numberFormat = [["0.00%"]];
                                    conditionalFormat = sheet.getRange("H10:H" + (9 + dataMatrix.length)).conditionalFormats.add(Excel.ConditionalFormatType.cellValue);
                                    conditionalFormat.cellValue.format.font.color = "#FF0000"; // Czerwony kolor czcionki dla lepszej czytelności
                                    conditionalFormat.cellValue.rule = {
                                        formula1: "1", // 100% w formacie dziesiętnym to 1
                                        operator: Excel.ConditionalCellValueOperator.greaterThan
                                    };
                                    // Synchronizacja przed select
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    // Synchronizacja przed select
                                    _a.sent();
                                    if (!eupType.isTrial) return [3 /*break*/, 4];
                                    trialNoticeRow = rowRange + 2;
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A".concat(trialNoticeRow, ":H").concat(trialNoticeRow), eupType.isTrial)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    copyrightRow = rowRange + 3;
                                    return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A".concat(copyrightRow, ":H").concat(copyrightRow))];
                                case 5:
                                    _a.sent();
                                    return [4 /*yield*/, context.sync()];
                                case 6:
                                    _a.sent();
                                    // Aktywuj arkusz
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [4 /*yield*/, context.sync()];
                                case 7:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda uaktualnia komórke C7 o aktualną datę i czas
 */
function updateTimestamp(sheet) {
    return __awaiter(this, void 0, void 0, function () {
        var currentdate, formattedDate;
        return __generator(this, function (_a) {
            currentdate = new Date();
            formattedDate = currentdate.toLocaleDateString("pl-PL", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
            });
            sheet.getRange("C7").values = [[formattedDate]];
            return [2 /*return*/];
        });
    });
}
/**
 * Metoda formatuje pojedynczy wiersz danych w arkuszu (kolumny A-H)
 * @param sheet - obiekt arkusza Excel z otwartego kontekstu
 * @param rowNumber - numer wiersza do sformatowania
 */
function formatSingleRow(sheet, rowNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var rowRange, columns, formula, conditionalFormat;
        return __generator(this, function (_a) {
            try {
                rowRange = sheet.getRange("A".concat(rowNumber, ":H").concat(rowNumber));
                // Wysokość wiersza
                rowRange.format.rowHeight = 30;
                // Kolor tła #F7F7F7
                rowRange.format.fill.color = "#F7F7F7";
                // Kolor czcionki #000000
                rowRange.format.font.color = "#000000";
                // Rozmiar czcionki 12
                rowRange.format.font.size = 12;
                // Wyrównanie tekstu do lewej
                rowRange.format.horizontalAlignment = "Left";
                // Wyrównanie pionowe do środka
                rowRange.format.verticalAlignment = "Center";
                // Dodanie border dół w kolorze #E8E8E8
                rowRange.format.borders.getItem("EdgeBottom").color = "#E8E8E8";
                rowRange.format.borders.getItem("EdgeBottom").weight = Excel.BorderWeight.thin;
                columns = ["A", "B", "C", "D", "E", "F", "G", "H"];
                columns.forEach(function (col) {
                    var cellRange = sheet.getRange("".concat(col).concat(rowNumber));
                    cellRange.format.borders.getItem("EdgeRight").color = "#E8E8E8";
                    cellRange.format.borders.getItem("EdgeRight").weight = Excel.BorderWeight.thin;
                });
                // Formatowanie specyficzne dla poszczególnych kolumn
                // Kolumny B i C - wyrównane do środka
                sheet.getRange("A".concat(rowNumber, ":B").concat(rowNumber)).format.horizontalAlignment = "Center";
                // Kolumna A - format tekstowy
                sheet.getRange("A".concat(rowNumber)).numberFormat = [["@"]];
                // Kolumna C - wyrównana do lewej z zawijaniem tekstu
                sheet.getRange("C".concat(rowNumber)).format.horizontalAlignment = "Left";
                sheet.getRange("C".concat(rowNumber)).format.wrapText = true;
                // Kolumny D-H - wyrównane do środka z formatem liczbowym 4 miejsca po przecinku
                sheet.getRange("D".concat(rowNumber, ":H").concat(rowNumber)).format.horizontalAlignment = "Center";
                sheet.getRange("D".concat(rowNumber, ":H").concat(rowNumber)).numberFormat = [["0.0000"]];
                // Kolumna H - specjalny kolor tła #E5EEF9
                sheet.getRange("G".concat(rowNumber)).format.fill.color = "#E5EEF9";
                formula = "=IF(OR(G".concat(rowNumber, "=0,G").concat(rowNumber, "=\"\"),\"nie dotyczy\",D").concat(rowNumber, "/G").concat(rowNumber, ")");
                sheet.getRange("H".concat(rowNumber)).formulas = [[formula]];
                sheet.getRange("H".concat(rowNumber)).numberFormat = [["0.00%"]];
                conditionalFormat = sheet.getRange("H".concat(rowNumber)).conditionalFormats.add(Excel.ConditionalFormatType.cellValue);
                conditionalFormat.cellValue.format.font.color = "#FF0000"; // Czerwony kolor czcionki dla lepszej czytelności
                conditionalFormat.cellValue.rule = {
                    formula1: "1", // 100% w formacie dziesiętnym to 1
                    operator: Excel.ConditionalCellValueOperator.greaterThan
                };
            }
            catch (error) {
                // TODO: Add error tracking - config?.appInsights?.trackException({ exception: error });
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Metoda sprawdza czy w wierszu 9 arkusza (kolumny A-H) są właściwe nagłówki z tablicy headers
 * @param sheetName - nazwa arkusza do sprawdzenia
 * @returns Promise<boolean> - zwraca true jeśli nagłówki w wierszu 9 są poprawne, false w przeciwnym przypadku
 */
function isSheetFormattedCorrectly(sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, headerRange, actualHeaders, allHeadersMatch, i, expectedHeader, actualHeader, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    headerRange = sheet.getRange("A9:H9");
                                    headerRange.load("values");
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    if (!headerRange.values || !headerRange.values[0]) {
                                        resolve(false);
                                        return [2 /*return*/];
                                    }
                                    actualHeaders = headerRange.values[0];
                                    allHeadersMatch = true;
                                    for (i = 0; i < headers.length; i++) {
                                        expectedHeader = headers[i];
                                        actualHeader = actualHeaders[i];
                                        if (!actualHeader || actualHeader.toString().trim() !== expectedHeader.trim()) {
                                            allHeadersMatch = false;
                                        }
                                    }
                                    if (!allHeadersMatch) {
                                        resolve(false);
                                        return [2 /*return*/];
                                    }
                                    resolve(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _a.sent();
                                    resolve(false);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                })];
        });
    });
}
/**
 * Metoda sprawdza ile wierszy z danymi jest od wiersza 10 w kolumnie A. Jezeli zanjdzie tam dane to wyłacza autosortowanie w arkuszu odczytuje wartosci z kolumny B i sprawdza czy jest to wartosc zgodna z formatem dwie cyfry spacja dwie cyfry spacje dwie cyfry i czasami * na koncu, jezeli tak dodaje do wasteCodeList i ustawia wartosc exists na true i zwraca tą listę jako wynik działania. W przeciwnym przypadku zwraca pustą listę.
 * @param sheetName - nazwa arkusza do sprawdzenia
 * @returns Promise<wasteCodeList[]> - zwraca listę wasteCodeList, jeśli dane są poprawne, lub pustą listę w przeciwnym przypadku
 */
function getWasteCodeList(sheetName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, dataRange, data, wasteCodeList, rowIndex, wasteCode, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    dataRange = sheet.getRange("A10:A");
                                    dataRange.load("values");
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    data = dataRange.values;
                                    wasteCodeList = [];
                                    for (rowIndex = 0; rowIndex < data.length; rowIndex++) {
                                        wasteCode = data[rowIndex][0];
                                        if ((0, common_1.isValidWasteCode)(wasteCode)) {
                                            wasteCodeList.push({ wasteCode: wasteCode, exists: true });
                                        }
                                    }
                                    resolve(wasteCodeList);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_2 = _a.sent();
                                    resolve([]);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                })];
        });
    });
}
/**
 * Metoda sprawdza wszystkie kody odpadu z matrix, wstawia dane do arkusza dla istniejących kodów i zwraca listę kodów, które NIE istnieją w arkuszu. Dla kodów istniejących w arkuszu wstawia odpowiadające dane z matrix do kolumn C-G. Kolumna H (maksymalnie według pozwolenia) NIE jest aktualizowana.
 * @param sheetName - nazwa arkusza do sprawdzenia
 * @param matrix - macierz danych z getKeoMatrix
 * @returns Promise<wasteCodeStatus[]> - zwraca listę kodów z matrix, które NIE istnieją w arkuszu (exists: false)
 */
function insertMatrixDataToSheet(sheetName, matrix) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var errorMsg, errorMsg, sheet, errorMsg, maxRows, dataRange, data, existingWasteCodes, rowIndex, wasteCode, cleanWasteCode, missingWasteCodeList, dataMatrix, _i, dataMatrix_1, matrixRow, matrixCode, existsInSheet, targetRowIndex, rowIndex, sheetCode, safeValues, error_3;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    // Walidacja parametrów wejściowych
                                    if (!sheetName || typeof sheetName !== 'string') {
                                        errorMsg = "❌ Nieprawidłowa nazwa arkusza";
                                        // TODO: Add error tracking - config?.appInsights?.trackException({ exception: new Error(errorMsg) });
                                        resolve([]);
                                        return [2 /*return*/];
                                    }
                                    if (!matrix || !Array.isArray(matrix) || matrix.length === 0) {
                                        errorMsg = "❌ Nieprawidłowa macierz danych";
                                        // TODO: Add error tracking - config?.appInsights?.trackException({ exception: new Error(errorMsg) });
                                        resolve([]);
                                        return [2 /*return*/];
                                    }
                                    sheet = void 0;
                                    try {
                                        sheet = context.workbook.worksheets.getItem(sheetName);
                                    }
                                    catch (sheetError) {
                                        errorMsg = "\u274C Nie mo\u017Cna znale\u017A\u0107 arkusza: ".concat(sheetName);
                                        // TODO: Add error tracking - config?.appInsights?.trackException({ exception: new Error(errorMsg) });
                                        resolve([]);
                                        return [2 /*return*/];
                                    }
                                    maxRows = 1000;
                                    dataRange = sheet.getRange("A10:A".concat(9 + maxRows));
                                    dataRange.load("values");
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _c.sent();
                                    data = dataRange.values;
                                    existingWasteCodes = new Set();
                                    if (data && data.length > 0) {
                                        for (rowIndex = 0; rowIndex < data.length; rowIndex++) {
                                            wasteCode = (_a = data[rowIndex]) === null || _a === void 0 ? void 0 : _a[0];
                                            if (wasteCode !== null && wasteCode !== undefined && wasteCode !== "") {
                                                cleanWasteCode = String(wasteCode).trim();
                                                if ((0, common_1.isValidWasteCode)(cleanWasteCode)) {
                                                    existingWasteCodes.add(cleanWasteCode);
                                                }
                                            }
                                        }
                                    }
                                    missingWasteCodeList = [];
                                    dataMatrix = matrix.slice(1);
                                    for (_i = 0, dataMatrix_1 = dataMatrix; _i < dataMatrix_1.length; _i++) {
                                        matrixRow = dataMatrix_1[_i];
                                        if (!matrixRow || !Array.isArray(matrixRow) || matrixRow.length === 0) {
                                            continue;
                                        }
                                        matrixCode = String(matrixRow[0] || "").trim();
                                        if (!(0, common_1.isValidWasteCode)(matrixCode)) {
                                            continue;
                                        }
                                        existsInSheet = existingWasteCodes.has(matrixCode);
                                        // Jeśli kod istnieje w arkuszu, zaktualizuj dane
                                        if (existsInSheet && matrixRow.length >= 6) {
                                            try {
                                                targetRowIndex = -1;
                                                for (rowIndex = 0; rowIndex < data.length; rowIndex++) {
                                                    sheetCode = String(((_b = data[rowIndex]) === null || _b === void 0 ? void 0 : _b[0]) || "").trim();
                                                    if (sheetCode === matrixCode) {
                                                        targetRowIndex = rowIndex + 10; // +10 bo zaczynamy od wiersza 10
                                                        break;
                                                    }
                                                }
                                                if (targetRowIndex > 0) {
                                                    safeValues = [
                                                        matrixRow[1] || "", // C - Odpad niebezpieczny 
                                                        matrixRow[2] || "", // D - Rodzaj odpadu
                                                        typeof matrixRow[3] === 'number' ? matrixRow[3] : 0, // E - Masa instalacji
                                                        typeof matrixRow[4] === 'number' ? matrixRow[4] : 0, // F - Masa poza instalacją
                                                        typeof matrixRow[5] === 'number' ? matrixRow[5] : 0 // G - Łączna masa
                                                    ];
                                                    // Wstaw dane do kolumn B-F
                                                    sheet.getRange("B".concat(targetRowIndex)).values = [[safeValues[0]]];
                                                    sheet.getRange("C".concat(targetRowIndex)).values = [[safeValues[1]]];
                                                    sheet.getRange("D".concat(targetRowIndex)).values = [[safeValues[2]]];
                                                    sheet.getRange("E".concat(targetRowIndex)).values = [[safeValues[3]]];
                                                    sheet.getRange("F".concat(targetRowIndex)).values = [[safeValues[4]]];
                                                }
                                            }
                                            catch (insertError) {
                                                // TODO: Add error tracking - config?.appInsights?.trackException({ exception: insertError });
                                            }
                                        }
                                        else if (!existsInSheet) {
                                            // Dodaj do listy tylko kody, które NIE istnieją w arkuszu
                                            missingWasteCodeList.push({
                                                wasteCode: matrixCode,
                                                exists: false
                                            });
                                        }
                                    }
                                    // Synchronizacja na końcu
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    // Synchronizacja na końcu
                                    _c.sent();
                                    // Update Time
                                    return [4 /*yield*/, updateTimestamp(sheet)];
                                case 3:
                                    // Update Time
                                    _c.sent();
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    resolve(missingWasteCodeList);
                                    return [3 /*break*/, 5];
                                case 4:
                                    error_3 = _c.sent();
                                    // TODO: Add error tracking - config?.appInsights?.trackException({ exception: error });
                                    resolve([]); // Zwróć pustą listę w przypadku błędu
                                    return [3 /*break*/, 5];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); }).catch(function (excelError) {
                        // TODO: Add error tracking - config?.appInsights?.trackException({ exception: excelError });
                        resolve([]);
                    });
                })];
        });
    });
}
/**
 * Metoda na podstawie listy obiektów wasteCodeStatus wyszukuje je w matrix  wstawia je do arkusza jako nowe wiersze po ostatnim wierszu z kodem odpadu w kolumnie B
 * @param sheetName - nazwa arkusza do wstawienia nowych kodów odpadu
 * @param wasteCodeList - lista kodów odpadu do wstawienia
 * @param matrix - macierz danych z getKeoMatrix do pobrania danych dla wstawianych kodów
 */
function insertMissingWasteCodes(sheetName, wasteCodeList, matrix) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, maxRows, dataRange, data, lastRowWithData, rowIndex, wasteCode, cleanWasteCode, newWasteCodes, _loop_2, i, error_4;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 9, , 10]);
                                    // Sprawdzenie czy wasteCodeList jest poprawne
                                    if (!Array.isArray(wasteCodeList) || wasteCodeList.length === 0) {
                                        return [2 /*return*/]; // Brak kodów do wstawienia
                                    }
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    maxRows = 1200;
                                    dataRange = sheet.getRange("A10:A".concat(9 + maxRows));
                                    dataRange.load("values");
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _b.sent();
                                    data = dataRange.values;
                                    lastRowWithData = 9;
                                    if (data && data.length > 0) {
                                        for (rowIndex = data.length - 1; rowIndex >= 0; rowIndex--) {
                                            wasteCode = (_a = data[rowIndex]) === null || _a === void 0 ? void 0 : _a[0];
                                            if (wasteCode !== null && wasteCode !== undefined && wasteCode !== "") {
                                                cleanWasteCode = String(wasteCode).trim();
                                                if ((0, common_1.isValidWasteCode)(cleanWasteCode)) {
                                                    lastRowWithData = rowIndex + 10; // +10 bo zaczynamy od wiersza 10
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    newWasteCodes = wasteCodeList.filter(function (item) { return !item.exists; });
                                    if (newWasteCodes.length === 0) {
                                        return [2 /*return*/]; // Brak nowych kodów do wstawienia
                                    }
                                    _loop_2 = function (i) {
                                        var insertRowIndex, wasteCode, insertRange, dataMatrix, matrixRow, newRow, safeValues;
                                        return __generator(this, function (_c) {
                                            switch (_c.label) {
                                                case 0:
                                                    insertRowIndex = lastRowWithData + 1 + i;
                                                    wasteCode = newWasteCodes[i].wasteCode;
                                                    insertRange = sheet.getRange("".concat(insertRowIndex, ":").concat(insertRowIndex));
                                                    insertRange.insert(Excel.InsertShiftDirection.down);
                                                    dataMatrix = matrix.slice(1);
                                                    matrixRow = dataMatrix.find(function (row) {
                                                        if (!row || !Array.isArray(row) || row.length === 0)
                                                            return false;
                                                        var matrixCode = String(row[0] || "").trim();
                                                        return matrixCode === wasteCode;
                                                    });
                                                    newRow = sheet.getRange("A".concat(insertRowIndex));
                                                    newRow.values = [[wasteCode]];
                                                    // Wstaw dane z matrix do kolumn B, C, D, E, F jeśli są dostępne
                                                    if (matrixRow && matrixRow.length >= 6) {
                                                        safeValues = [
                                                            matrixRow[1] || "", // B - Odpad niebezpieczny
                                                            matrixRow[2] || "", // C - Rodzaj odpadu
                                                            typeof matrixRow[3] === 'number' ? matrixRow[3] : 0, // D - Masa instalacji
                                                            typeof matrixRow[4] === 'number' ? matrixRow[4] : 0, // E - Masa poza instalacją
                                                            typeof matrixRow[5] === 'number' ? matrixRow[5] : 0 // F - Łączna masa
                                                        ];
                                                        // Wstaw dane do kolumn B-F
                                                        sheet.getRange("B".concat(insertRowIndex)).values = [[safeValues[0]]];
                                                        sheet.getRange("C".concat(insertRowIndex)).values = [[safeValues[1]]];
                                                        sheet.getRange("D".concat(insertRowIndex)).values = [[safeValues[2]]];
                                                        sheet.getRange("E".concat(insertRowIndex)).values = [[safeValues[3]]];
                                                        sheet.getRange("F".concat(insertRowIndex)).values = [[safeValues[4]]];
                                                    }
                                                    // Sformatuj nowy wiersz używając istniejącej metody
                                                    return [4 /*yield*/, formatSingleRow(sheet, insertRowIndex)];
                                                case 1:
                                                    // Sformatuj nowy wiersz używając istniejącej metody
                                                    _c.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    };
                                    i = 0;
                                    _b.label = 2;
                                case 2:
                                    if (!(i < newWasteCodes.length)) return [3 /*break*/, 5];
                                    return [5 /*yield**/, _loop_2(i)];
                                case 3:
                                    _b.sent();
                                    _b.label = 4;
                                case 4:
                                    i++;
                                    return [3 /*break*/, 2];
                                case 5: return [4 /*yield*/, context.sync()];
                                case 6:
                                    _b.sent();
                                    // Update Time
                                    return [4 /*yield*/, updateTimestamp(sheet)];
                                case 7:
                                    // Update Time
                                    _b.sent();
                                    // Ustaw aktywną komórkę na A1
                                    sheet.getRange("A1").select();
                                    sheet.activate();
                                    return [4 /*yield*/, context.sync()];
                                case 8:
                                    _b.sent();
                                    return [3 /*break*/, 10];
                                case 9:
                                    error_4 = _b.sent();
                                    return [3 /*break*/, 10];
                                case 10: return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=keo_annual_report_with_permit.js.map